/**
 * A module representing tooltip component.
 * @module tooltip
 * @exports Tooltip
 * @see Tooltip
 * @requires module:training
 * @example
 * var Tooltip = require('tooltip');
 */
define('tooltip',['jquery', 'helperContent-customText'], function($, customText) {
    'use strict';

    var tooltip,
        closeBtnHtml = '<span class="hotspot-close"> <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16"> <rect class="modal-ico-close" x="-1.979" y="6.979" transform="matrix(0.7071 0.7071 -0.7071 0.7071 7.9916 -3.3349)" width="20" height="2"/> <rect class="modal-ico-close" x="-1.979" y="6.98" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 19.3361 7.9502)" width="20.001" height="2"/> </svg> </span>';

    /**
     * @constructor
     * @alias Tooltip
     */
    function Tooltip() {

    }

    /**
     *
     * @param gbObj
     */
    Tooltip.prototype.setupGuideBubble = function(gbObj) {
        var body = document.body,
            html = document.documentElement,
            docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight), docWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth),
            elLeft = $(gbObj.element).offset().left,
            elTop = $(gbObj.element).offset().top,
            posX = elLeft < (docWidth / 2) ? 'right' : 'left',
            posY = elTop < (docHeight / 2) ? 'bottom' : 'top',
            myPos = (posY === 'bottom' ? 'top' : 'bottom'),

            showDelay = Number(gbObj.showDelay) || 0,
            duration = Number(gbObj.duration),
            text = gbObj.text,
            element = gbObj.element,
            interaction = gbObj.interaction || false,
            clickable = gbObj.interactionTypeClick || false;

        if (Math.abs(elTop - docHeight / 2) < (docHeight * 0.6 / 2)) {
            posY = 'center';
            myPos = 'center';
        }

        $(element).qtip({
            content: {
                text: interaction ? (!clickable ? text : text + closeBtnHtml) : duration ? text : text + closeBtnHtml
            },
            style: {
                classes: 'gptooltip instructiontip',
                tip: {
                    corner: true,
                    offset: 0,
                    width: 15,
                    height: 10
                }
            },
            show: {
                ready: !interaction,
                event: interaction ? (clickable ? 'click':'click mouseenter') : false,
                delay: interaction ? 0 : (showDelay || 0),
                effect: function() {
                    $(this).fadeIn(300);
                }
            },
            hide: {
                fixed: true,
                event: interaction ? (clickable ? 'click':'unfocus mouseleave') : false,
                effect: function() {
                    $(this).fadeOut(150);
                }
            },
            position: {
                my: (posX === 'left' ? 'right' : 'left') + ' ' + myPos,
                at:  posY + ' ' + posX,
                viewport: $(window),
                target: $(element),
                adjust: {
                    method: 'shift shift',
                    resize: true,
                    x: posX === 'right' ? 5 : -5
                }
            },
            events: {
                focus: function(event, api) {
                    var classesArr = api.elements.target.attr('class') ? api.elements.target.attr('class').split(' ') : [];
                    if (classesArr.indexOf('qtip-open') < 0) {
                        classesArr.push('qtip-open');
                        api.elements.target.attr('class', classesArr.join(' '));
                    }
                },
                blur: function(event, api) {
                    var classesArr = api.elements.target.attr('class') ? api.elements.target.attr('class').split(' ') : [];
                    if (classesArr.indexOf('qtip-open') > -1) {
                        classesArr.splice(classesArr.indexOf('qtip-open'));
                        api.elements.target.attr('class', classesArr.join(' '));
                    }
                },
                render: function (event, api) {
                    if (duration && !interaction) {
                        setTimeout(function () {
                            api.hide();
                        }, duration);
                    } else {
                        api.elements.tooltip.click(function(){
                            api.hide();
                        });
                    }
                }
            }
        });

    };


    /**
     * @param scope
     */

    //TODO this should be removed when possible
    Tooltip.prototype.setGPTooltips = function(scope) {

        // create new gptooltip elements
        var ttElements = document.querySelectorAll('[data-tooltip-textid]');

        for (var i=0; i<ttElements.length;i++) {

            var clickable = ttElements[i].hasAttribute('data-tooltip-clickable'),
                textContent = customText.getCustomText(scope,ttElements[i].getAttribute('data-tooltip-textid')),
                ttContent = clickable ? textContent + closeBtnHtml : textContent;

            $(ttElements[i]).qtip({
                content: ttContent,
                show: clickable ? 'click':'click mouseenter',
                hide: clickable ? 'click':'unfocus mouseleave',

                position: {
                    my: 'bottom left',
                    container: document.body,
                    viewport: $('#player'),
                    target: 'mouse',

                    adjust: {
                        method: clickable ? 'shift shift':'shift shift',
                        mouse: !clickable,
                        screen: true
                    }
                },

                style: {
                    classes: 'gptooltip',
                    tip: {
                        corner: true,
                        mimic: false,
                        height: 10,
                        width: 15
                    }
                },

                events: {
                    focus: function(event, api) {
                        var classesArr = api.elements.target.attr('class') ? api.elements.target.attr('class').split(' ') : [];
                        if (classesArr.indexOf('qtip-open') < 0) {
                            classesArr.push('qtip-open');
                            api.elements.target.attr('class', classesArr.join(' '));
                        }
                    },
                    blur: function(event, api) {
                        var classesArr = api.elements.target.attr('class') ? api.elements.target.attr('class').split(' ') : [];
                        if (classesArr.indexOf('qtip-open') > -1) {
                            classesArr.splice(classesArr.indexOf('qtip-open'));
                            api.elements.target.attr('class', classesArr.join(' '));
                        }
                    },
                    render: function(event,api) {
                        api.elements.tooltip.click(function(){
                            api.hide();
                        });
                    }
                }
            })
        }
    };

    // TODO move all hotspots related tip functions here

    return function() {

        if (!tooltip) {
            tooltip = new Tooltip();
        }

        return tooltip;
    };
});

